import { orDefault } from '@/common/utils';

const vehicleMixin = {
  computed: {
    fahrzeuge() {
      return this.$route.path.includes('unfalldesk') ? this.$store.state.unfalldesk.fahrzeuge : this.$store.state.wagenbuch.fahrzeuge;
    },
    fzId() {
      return Number(this.$route.params.fzId ? this.$route.params.fzId : this.$route.query.fzId);
    },
    vehicle() {
      const vehicle = this.fahrzeuge.find((f) => f.id === this.fzId);
      console.log(`Selected vehicle route query param fzId=${this.fzId} vehicle=${JSON.stringify(vehicle, null, 2)}`);
      return vehicle;
    },
    fzName() {
      if (this.vehicle) {
        return this.vehicle.fzName;
      }
      return this.$route.params.fzName ? this.$route.params.fzName : this.$route.query.fzName;
    },
  },
};

export default vehicleMixin;
